export default __webpack_public_path__ + "static/search-page-28647f460cdbd24956aed2cff8b044e5.png";